import { flexRender, type ColumnDef } from '@/lib/tanstack-table';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { CalculatedOnHover } from './quantityOverrideCells';

/** The Qty column for the Simple display: Calc moves into the hover. */
export function withCalculatedOnHover(
  column: ColumnDef<AssignmentLine>,
): ColumnDef<AssignmentLine> {
  return {
    ...column,
    cell: (context) => (
      <CalculatedOnHover line={context.row.original}>
        {flexRender(column.cell, context)}
      </CalculatedOnHover>
    ),
  };
}
